import RadioCards from '@/common/components/RadioCards'
import CreateForwardingDirectiveEntryFormStepAccordion from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepAccordion'
import { checkinEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant'
import {
  MaintenanceForwardingsCheckinEntryStepOptions,
  MaintenanceForwardingsDirectiveFromSteps,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { CheckinEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

const CheckinEntryFormStepPending = ({
  state,
  attributes,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.CheckinEntry>) => {
  const { control, setValue } = useFormContext<CheckinEntryValidationSchema>()

  const { setUpdatedValueAt } = useCreateForwardingsFormStore()

  const { checkin_entry_type: watchCheckinEntryType } = useWatch({
    control,
  })

  const EntryOptionComponent = useMemo(() => {
    if (watchCheckinEntryType) {
      const checkinEntryOption =
        checkinEntryOptions[watchCheckinEntryType as MaintenanceForwardingsCheckinEntryStepOptions]

      return checkinEntryOption.components.pending
    }

    return null
  }, [watchCheckinEntryType])

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Método de check-in"
      body={
        <div>
          {!watchCheckinEntryType && (
            <RadioCards
              options={(attributes as MaintenanceForwardingsCheckinEntryStepOptions[])
                ?.filter((option) => !!checkinEntryOptions[option])
                ?.map((option) => {
                  const checkinEntryOption = checkinEntryOptions[option]

                  return {
                    value: option,
                    title: checkinEntryOption.title,
                    description: checkinEntryOption.description,
                  }
                })}
              value={watchCheckinEntryType}
              onValueChange={(value) => {
                setUpdatedValueAt()
                setValue('checkin_entry_type', value)
              }}
            />
          )}

          {watchCheckinEntryType && EntryOptionComponent && <EntryOptionComponent />}
        </div>
      }
    />
  )
}

export default CheckinEntryFormStepPending
